export const FAKE_AUTH_ISSUER = 'https://cypress-made-up-idp.com';
